import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TimelineSection() {
  const phases = [{
    days: 'Día 1-7',
    title: 'Alquimia',
    description: 'Seleccionas tus bases y creas tus primeros 5 blends usando nuestro recetario de autor.',
    number: '01'
  }, {
    days: 'Día 8-14',
    title: 'Identidad',
    description: 'Aplicas la ingeniería de costos y el packaging de lujo para tener un producto que se vea de $50 pero te cueste $5 producir.',
    number: '02'
  }, {
    days: 'Día 15-21',
    title: 'Fuga',
    description: 'Lanzamos tu marca en Instagram con nuestro pack de textos y estrategia viral para conseguir tus primeras ventas.',
    number: '03'
  }];
  return <section className="py-14 px-6 lg:px-8 bg-white relative" data-id="element-340">
      <div className="max-w-5xl mx-auto" data-id="element-341">
        <FadeIn data-id="element-342">
          <div className="text-center mb-16" data-id="element-343">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-tea-green mb-4" data-id="element-344">
              Tu Hoja de Ruta de 21 Días
            </h2>
            <p className="text-lg text-tea-charcoal/60 font-body" data-id="element-345">
              Un paso a paso claro, sin abrumarte.
            </p>
          </div>
        </FadeIn>

        <div className="relative" data-id="element-346">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-tea-sage/50 -translate-y-1/2 z-0" data-id="element-347"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-348">
            {phases.map((phase, index) => <FadeIn key={index} delay={0.2 * (index + 1)} direction="up" data-id="element-349">
                <div className="bg-tea-cream rounded-2xl p-8 border border-tea-sage/60 relative group hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-md" data-id="element-350">
                  {/* Number indicator */}
                  <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-tea-gold rounded-full flex items-center justify-center text-tea-green font-bold text-xl border-4 border-white shadow-sm" data-id="element-351">
                    {phase.number}
                  </div>

                  <div className="text-center mt-6" data-id="element-352">
                    <span className="text-sm font-bold tracking-widest text-tea-gold uppercase mb-2 block" data-id="element-353">
                      {phase.days}
                    </span>
                    <h3 className="text-2xl font-heading font-bold text-tea-green mb-4" data-id="element-354">
                      {phase.title}
                    </h3>
                    <p className="text-tea-charcoal/80 leading-relaxed" data-id="element-355">
                      {phase.description}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}